<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Konfigurator fakturowania <small class="text-red-400 text-xs">(Wszystkie pola wymagane)</small></h1>

    <div class="flex flex-wrap">
      <div class="bg-white rounded-md shadow overflow-hidden w-full lg:w-3/4">

        <form @submit.prevent="update">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

            <multiselect-input v-model="form.firma" :error="form.errors.firma" class="pr-6 pb-8 w-full" :options="firmy" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Firma wystawiająca faktury" :isDisabled="true" />

            <multiselect-input v-model="form.uzytkownik" :error="form.errors.uzytkownik" class="pr-6 pb-8 w-full lg:w-1/2" :options="uzytkownicy" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Użytkownik" />

            <multiselect-input v-model="form.pracownik" :error="form.errors.pracownik" class="pr-6 pb-8 w-full lg:w-1/2" :options="pracownicy" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Pracownik" />

            <multiselect-input v-model="form.typ_dok_handl" :error="form.errors.typ_dok_handl" class="pr-6 pb-8 w-full lg:w-1/2" :options="typy_dok_handl" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Typ wystawianego dokumentu handlowego" />

            <multiselect-input v-model="form.typ_dok_mag" :error="form.errors.typ_dok_mag" class="pr-6 pb-8 w-full lg:w-1/2" :options="typy_dok_mag" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Typ dokumentu magazynowego" />

            <multiselect-input v-model="form.kasa" :error="form.errors.kasa" class="pr-6 pb-8 w-full lg:w-1/2" :options="kasy" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Kasa firmy" />

            <multiselect-input v-model="form.rachunek" :error="form.errors.rachunek" class="pr-6 pb-8 w-full lg:w-1/2" :options="rachunki" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Rachunek bankowy firmy" />

            <multiselect-input v-model="form.rth" :error="form.errors.rth" class="pr-6 pb-8 w-full lg:w-1/2" :options="transaction_types" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Rodzaj transakcji handlowej" />

            <text-input v-model="form.miejsce" :error="form.errors.miejsce" class="pr-6 pb-8 w-full lg:w-1/2" label="Miejsce wystawiania faktur" />

          </div>
          <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center" v-if="$page.props.can['update configs']">
            <loading-button :loading="form.processing" class="btn-shtax ml-auto" type="submit">Zapisz konfigurację</loading-button>
          </div>
            
        </form>
      </div>

    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'

export default {
  metaInfo: { title: 'Konfigurator fakturowania' },
  components: {
    TextInput,
    LoadingButton,
    MultiselectInput
  },
  layout: Layout,
  remember: 'form',
  props: {
    config: Object,
    firmy: Array,
    uzytkownicy: Array,
    pracownicy: Array,
    typy_dok_handl: Array,
    typy_dok_mag: Array,
    kasy: Array,
    rachunki: Array,
    transaction_types: Array
  },
  data() {
    return {
      form: this.$inertia.form({
        firma: this.config.firma,
        uzytkownik: this.config.uzytkownik,
        pracownik: this.config.pracownik,
        typ_dok_handl: this.config.typ_dok_handl,
        typ_dok_mag: this.config.typ_dok_mag,
        kasa: this.config.kasa,
        rachunek: this.config.rachunek,
        miejsce: this.config.miejsce,
        rth: this.config.rth
      })
    }
  },
  methods: {
    update() {
      this.form.put(this.route('factures.config.update'))
    },
  },
}
</script>
